import * as React from 'react';
import * as S from './styles';
import * as T from './types';
import FilterCheck from 'components/Filter';
import { capitalizeFirstLetter } from '../../state/utils';
import { getRatingRecommended } from '../utils';

const ReviewCard: React.FC<T.IProps> = (props) => {

    const renderName = (name: string) => {
        let reviewer = name.split(" ");
        if (reviewer.length === 2) reviewer[1] = reviewer[1][0] ? ` ${reviewer[1][0]?.toUpperCase()}.` : "";
        return reviewer.join("");
    }

    const renderDate = () => {
        const date = new Date(props.review.date);
        return date.toLocaleDateString("en-US");
    }

    const handleSelectReview = () => {
        if (props.handleSelectReviews) props.handleSelectReviews(props.review);
    }

    const checked = !(props.selected === false);

    return (
        <S.Root style={props.style} >
            <S.Metadata>
                <S.MetaName>
                    {renderName(props.review.reviewer)}
                </S.MetaName>
                <S.MetaLocation>
                </S.MetaLocation>
                <S.MetaUrl
                    target="_blank"
                    href={props.review.url}
                >
                    {`via ${capitalizeFirstLetter(props.review.provider)}`}
                </S.MetaUrl>
                {
                    props.dateLocation === "left" &&
                    <S.MetaDate>
                        {renderDate()}
                    </S.MetaDate>
                }
            </S.Metadata>
            <S.Content marginBottomValue={props.showFeatureCheck ? "35px" : "0px"} >
                <S.ContentStars>
                    {getRatingRecommended({
                        provider: props.review.provider,
                        recommended: props.review.recommended,
                        rating: props.review.rating,
                        starStyle: {width: "14px", height: "14px"},
                        thumbsStyle: {width: "14", height: "13"},
                    } )}
                </S.ContentStars>
                {
                    props.dateLocation === "right" &&
                    <S.ContentDate>
                        {renderDate()}
                    </S.ContentDate>
                }
                <S.ContentTitle>
                    {props.review.header}
                </S.ContentTitle>
                <S.ContentDetail>
                    {props.review.detail}
                </S.ContentDetail>
            </S.Content>
            {
                props.showFeatureCheck &&
                <S.ContentFeatureContainer>
                    <FilterCheck
                        key={`review-${props.review.id}`}
                        label={`Feature`}
                        type={`review-card`}
                        onChange={handleSelectReview}
                        checked={checked}
                        styleRoot={{ padding: '0px 0px', height: "29px" }}
                        styledCheckbox={{
                            borderRadius: '5px',
                            border: checked ? 'none' : 'solid 2px rgba(189, 189, 189, 0.5)',
                            background: checked ? '#2b3a66' : '#fff',
                            width: checked ? '22px' : '19.5px',
                            height: checked ? '22px' : '19.5px',
                        }}
                        styleLabel={{
                            fontSize: '14px',
                            color: '#000',
                            marginLeft: '9px'
                        }}
                        stroke='#fff'
                    />
                </S.ContentFeatureContainer>
            }
        </S.Root>
    );
}

export default ReviewCard;
